<template>
  <div id="daily-fiber">
    <div class="tw-grid tw-grid-cols-1 tw-gap-y-1">
      <b-form-group :label="$t('tools.fiber.dailyIntake')" label-for="edit-kcal">
        <b-input-group :append="$t('tools.append.kcal')">
          <b-form-input id="edit-kcal" v-model="kcal" :placeholder="$t('tools.fiber.placeholder.dailyIntake')"
                        type="text"
                        v-decimal
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <div class="tw-text-right">
        <b-button variant="primary" @click="calculate">{{ $t('tools.fiber.btn') }}</b-button>
      </div>

      <div v-if="result" class="tw-mt-2">
        <div class="tool-result" v-html="$t('tools.fiber.result', { result, unit: $t('tools.append.g') })" />
      </div>
    </div>
  </div>
</template>

<script>
import {round} from '@utils/numbers';

export default {
  data() {
    return {
      kcal: null,
      result: null
    }
  },
  methods: {
    calculate() {
      this.result = round(this.kcal / 1000 * 14);
    }
  }
}

</script>
